module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"categories":"Kategorien","new":"Neu"},"en":{"categories":"Categories","new":"New"}}')
  delete Component.options._Ctor
}
